module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item; 
    ; __append("\n\n<div class=\"spl-object-page\">\n    <div class=\"table w100\">\n        ")
    ;  if (isRoot()) { 
    ; __append("\n        <div class=\"section\">\n            <div class=\"title\">ID</div>\n            <div>\n                ")
    ; __append(escapeFn( item.id ))
    ; __append("\n            </div>\n        </div>\n        ")
    ;  } 
    ; __append("\n        <div class=\"section\">\n            <div class=\"title\">UUID</div>\n            <div>\n                <div\n                    ")
    ;  if (isRoot()) { 
    ; __append("\n                    data-control-type=\"text\"\n                    data-control-target=\"item.uid\"\n                    ")
    ;  } 
    ; __append("\n                >\n                    ")
    ; __append(escapeFn( item.uid ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        <div class=\"section\">\n            <div class=\"title\">Класс ПД</div>\n            <div>\n                <div\n                    data-control-type=\"data-autocomplete\"\n                    data-control-target=\"item.classname\"\n                    data-control-source=\"Spatial.Data.Classes\"\n                    data-control-column=\"name\"\n                    data-control-columns=\"id,name\"\n                    data-control-bind=\"item.classid:id;item.layerid:id;item.feature.layerid:id;item.codeid:codeid;item.classcodename:classcodename\"\n                    data-control-on-select=\"onClassSelect\"\n                >\n                    ")
    ; __append(escapeFn( item.classname ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        <div class=\"section\">\n            <div class=\"title\">Классификатор</div>\n            <div>\n                <div name=\"classcodename\">\n                    ")
    ; __append(escapeFn( item.classcodename ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        <div class=\"section\">\n            <div class=\"title\">Поставщик</div>\n            <div>\n                <div\n                    ")
    ;  if (isRoot()) { 
    ; __append("\n                    data-control-type=\"data-autocomplete\"\n                    data-control-target=\"item.providername\"\n                    data-control-source=\"Provider.Data.Providers\"\n                    data-control-column=\"name\"\n                    data-control-columns=\"#{id}|{name} <i>({subname})</i><br><span>{refclass}</span>\"\n                    data-control-bind=\"item.providerid:id\"\n                    ")
    ;  } 
    ; __append("\n                >\n                    ")
    ; __append(escapeFn( item.providername ))
    ; __append("\n                </div>\n            </div>\n        </div>\n    </div>\n    <div name=\"attributes\"></div>\n</div>\n")
  }
  return __output.join("");

}